export const projectsData = [
  {
    name: 'Boat Safari Website',
    technologies: 'HTML, CSS, JavaScript',
    year: '2020'
  },
  {
    name: 'Employee Management System',
    technologies: 'MVC, Java, MySQL',
    year: '2020'
  },
  {
    name: 'Hotel Management System',
    technologies: 'MERN Stack',
    year: '2020'
  },
  {
    name: 'Restaurant Management System',
    technologies: 'Java, Android Studio, SQLite',
    year: '2021'
  },
  {
    name: 'TODO Mobile App',
    technologies: 'Flutter',
    year: '2023'
  },
  {
    name: 'Research Website',
    technologies: 'React JS',
    year: '2023'
  }
];

export const personalprojectsData = [
  {
    name: 'VisitLanka',
    technologies: 'MERN Stack',
    year: '2023',
    webUrl: 'https://visitlanka.pages.dev/'
  },
  {
    name: 'Healthcare Management System',
    technologies: 'Spring Boot, React JS, MySQL',
    year: '2023',
    webUrl: 'https://healthcare-management-system.pages.dev/'
  }
];

export const industrialprojectsData = [
  {
    name: 'Credit Card Integration',
    technologies: 'Yalamanchili, LOLC Technologies',
    year: '2025'
  }
];
